module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( vote_date.toLocaleDateString("en-US", {"dateStyle":"medium"}) ))==null?'':__t)+
'</td>\n<td>\n  ';
 bills.forEach(function(bill) { 
__p+='\n    <a class="bill-link" href="#bills/'+
((__t=( bill['bill_id'] ))==null?'':__t)+
'" oncontextmenu="return false">'+
((__t=( bill['document_type'] ))==null?'':__t)+
''+
((__t=( bill['number'] ))==null?'':__t)+
'</a>  \n  ';
 }); 
__p+='\n</td>\n<td>'+
((__t=( caption ))==null?'':__t)+
'</td>\n<td class="text-end voted '+
((__t=( voted ))==null?'':__t)+
'">'+
((__t=( voted ))==null?'':__t)+
'</td>\n';
}
return __p;
};
